import {Route, Switch} from "react-router-dom";
import {Container} from "react-bootstrap";
import React from "react";
import Footer from "./Footer";
import ShortFooter from "./ShortFooter";

const HandleFooter = () =>{
    return (
        <Container fluid={true} className="bg-white">
            <Switch>
                <Route exact path={'/stores'} >
                    <div id={'short-footer'} >
                        <ShortFooter/>
                    </div>
                </Route>
                <Route exact path={'/intro'} >
                    <div id={'short-footer'} >
                        <ShortFooter/>
                    </div>
                </Route>
                
                <Route path={'*'}>
                    <div id={'base-footer'}>
                        <Footer/>
                    </div>
                </Route>
            </Switch>
        </Container>
    )
}
export default HandleFooter;
